<template>
  <div class="container-fluid customer-home-container pt-2">
    <b-row class="mt-3">
      <b-col>
        <b-alert show variant="astrology">
        
          <p>
           To create your interactive Birth chart please share your Be-Earth (Birth) information - 
           <router-link to="/astrology_ventures/create_birth_chart">  Click here!! </router-link>
          </p>
        </b-alert></b-col
      >
    </b-row>
    <!-- welcome user -->
    <b-row>
      <b-col lg="6" class="mx-auto mt-3">
        <h2 class="welcomeUserHomeH2Astrology">Hello {{ user_name }}</h2>
        <p class="welcomeUserHomePAstrology">What will brings you today?</p>
      </b-col>
    </b-row>
    <!-- media images  -->
    <!-- movement-home-default , meditation-home-default , movement-home-hover.png, music-home-hover.png -->
    <b-row class="mb-5">
      <b-col lg="4" md="6" class="mediaImageHomeContainerAstrologyDiv mb-4">
        <b-card
          class="mediaImageHomeAstrologyCard m-0 mediaImageDefaultDiv"
          overlay
          :img-src="
            require('@/assets/images/astrology/birth-chart-home-default.png')
          "
          img-alt="Card Image"
          text-variant="white"
        >
          <!-- <b-card-text>EXPLORE BIRTH CHART </b-card-text> -->
        </b-card>
        <b-card
          class="mediaImageHomeAstrologyCard m-0 mediaImageHoverDiv"
          overlay
          :img-src="
            require('@/assets/images/astrology/birth-chart-home-hover.png')
          "
          img-alt="Card Image"
          text-variant="white"
          title=""
        >
          <!-- <b-card-text>
            <span> Interactive </span><span>Learning Kit</span>
          </b-card-text>
          <router-link
            to="/astrology_ventures/movement"
            class="btn btn-outline-home-astrology"
            >View now</router-link
          > -->
          <!-- <button class="btn btn-outline-home-astrology">Practice now</button> -->
        </b-card>
      </b-col>
      <b-col lg="4" md="6" class="mediaImageHomeContainerAstrologyDiv mb-4">
        <b-card
          class="mediaImageHomeAstrologyCard m-0 mediaImageDefaultDiv"
          overlay
          :img-src="
            require('@/assets/images/astrology/astrology-metaverse-home-default.png')
          "
          img-alt="Card Image"
          text-variant="white"
        >
          <!-- <b-card-text>Astrology Metaverse </b-card-text> -->
        </b-card>
        <b-card
          class="mediaImageHomeAstrologyCard m-0 mediaImageHoverDiv"
          overlay
          :img-src="
            require('@/assets/images/astrology/astrology-metaverse-home-hover.png')
          "
          img-alt="Card Image"
          text-variant="white"
          title=""
        >
          <!-- <b-card-text>
            <span>Audio Visual
 </span>
            <span>Immersions</span>
          </b-card-text>
          <router-link
            to="/astrology_ventures/meditation"
            class="btn btn-outline-home-astrology"
            >View now</router-link
          > -->
          <!-- <button class="btn btn-outline-home-astrology">Meditate now</button> -->
        </b-card>
      </b-col>
      <b-col lg="4" md="6" class="mediaImageHomeContainerAstrologyDiv mb-4">
        <b-card
          class="mediaImageHomeAstrologyCard m-0 mediaImageDefaultDiv"
          overlay
          :img-src="
            require('@/assets/images/astrology/soul-journey-home-default.png')
          "
          img-alt="Card Image"
          text-variant="white"
        >
          <!-- <b-card-text>Music </b-card-text> -->
        </b-card>
        <b-card
          class="mediaImageHomeAstrologyCard m-0 mediaImageHoverDiv"
          overlay
          :img-src="
            require('@/assets/images/astrology/soul-journey-home-hover.png')
          "
          img-alt="Card Image"
          text-variant="white"
          title=""
        >
          <!-- <b-card-text>
            <span>Nada yoga</span>
            <span>Music playlists exclusive music</span>
          </b-card-text>
          <router-link
            to="/astrology_ventures/music"
            class="btn btn-outline-home-astrology"
            >View now</router-link
          > -->
          <!-- <button class="btn btn-outline-home-astrology">Listen now</button> -->
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "AstrologyCustomerHome",
  components: {},
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      user_name: "",
    };
  },
  mounted() {
    // console.log()
    // console.log(window.localStorage.getItem("user"))
    let user = window.localStorage.getItem("user");
    if (user != null) {
      let user_json = JSON.parse(user);
      //  console.log(user)
      this.user_name = user_json.name;
    }
  },
};
</script>

<style scoped::v-deep >
</style>


// WEBPACK FOOTER //
// src/components/astrology_ventures/customer/Home.vue